import index from "@/views/index/index.vue";


const routes = [
  // {
  //   path: '*',
  //   redirect: '/launchPage'
  // },

  // {
  //   path: '/launchPage',
  //   component: launchPage,
  //   name: 'launchPage',
  //   meta: {
  //     title: '百分百生活馆',
  //     keepAlive: false
  //   }
  // },
  {
    path: '*',
    redirect: '/index',
    keepAlive: false
  },
  {
    path: '/index',
    component: index,
    name: 'index',
    meta: {
      title: '首页',
      keepAlive: false
    }
  },
  {
    path: '/author',
    name: 'author',
    component: (resolve) => require(['@/views/author/author.vue'], resolve),
    meta: {
      // 微信授权
      title: '百分百生活馆',
      keepAlive: false
    }
  },
  {
    path: '/login',
    name: 'login',
    component: (resolve) => require(['@/views/login/login.vue'], resolve),
    meta: {
      title: '登陆',
      keepAlive: false
    }
  },
  {
    path: '/new-bind',
    name: 'new-bind',
    component: (resolve) => require(['@/views/login/new-bind.vue'], resolve),
    meta: {
      // 重新绑定
      title: '注册',
      keepAlive: false
    }
  },
  {
    path: '/reset-pwd',
    name: 'reset-pwd',
    component: (resolve) => require(['@/views/login/reset-pwd.vue'], resolve),
    meta: {
      // 重新绑定
      title: '忘记密码',
      keepAlive: false
    }
  },
  {
    path: '/bj-login',
    name: 'bj-login',
    component: (resolve) => require(['@/views/login/bj-login.vue'], resolve),
    meta: {
      title: '登陆',
      keepAlive: false
    }
  },
  {
    path: '/category',
    name: 'category',
    component: (resolve) => require(['@/views/category/category.vue'], resolve),
    meta: {
      title: '分类',
      keepAlive: true
    }
  },
  {
    path: '/category-list',
    name: 'category-list',
    component: (resolve) => require(['@/views/category/category-list.vue'], resolve),
    meta: {
      title: '分类商品',
      keepAlive: true
    }
  },
  {
    path: '/shopping-car',
    name: 'shopping-car',
    component: (resolve) => require(['@/views/shopping-car/shopping-car.vue'], resolve),
    meta: {
      title: '购物车',
      keepAlive: false
    }
  },

  {
    path: '/mine',
    name: 'mine',
    component: (resolve) => require(['@/views/mine/mine.vue'], resolve),
    meta: {
      title: '个人中心',
      keepAlive: false
    }
  },
  {
    path: '/mine-service',
    name: 'mine-service',
    component: (resolve) => require(['@/views/mine/mine-service.vue'], resolve),
    meta: {
      title: '个人设置',
      keepAlive: false
    }
  },
  {
    path: '/mine-balance',
    name: 'mine-balance',
    component: (resolve) => require(['@/views/mine/mine-balance.vue'], resolve),
    meta: {
      title: '我的账户',
      keepAlive: false
    }
  },
  {
    path: '/balance-log-list',
    name: 'balance-log-list',
    component: (resolve) => require(['@/views/mine/balance-log-list.vue'], resolve),
    meta: {
      title: '余额交易记录',
      keepAlive: false
    }
  },
  {
    path: '/adderss-edit',
    name: 'adderss-edit',
    component: (resolve) => require(['@/views/adderss/adderss-edit.vue'], resolve),
    meta: {
      title: '编辑地址',
      keepAlive: false
    }
  },

  {
    path: '/adderss-list',
    name: 'adderss-list',
    component: (resolve) => require(['@/views/adderss/adderss-list.vue'], resolve),
    meta: {
      title: '地址列表',
      keepAlive: false
    }
  },
  {
    path: '/mine-about',
    name: 'mine-about',
    component: (resolve) => require(['@/views/mine/mine-about.vue'], resolve),
    meta: {
      title: '关注我们',
      keepAlive: false
    }
  },
  {
    path: '/mine-collection',
    name: 'mine-collection',
    component: (resolve) => require(['@/views/mine/mine-collection.vue'], resolve),
    meta: {
      title: '我的收藏',
      keepAlive: false
    }
  },
  {
    path: '/mine-foot-print',
    name: 'mine-foot-print',
    component: (resolve) => require(['@/views/mine/mine-foot-print.vue'], resolve),
    meta: {
      title: '我的足迹',
      keepAlive: false
    }
  },
  {
    path: '/mine-coupon',
    name: 'mine-coupon',
    component: (resolve) => require(['@/views/mine/mine-coupon.vue'], resolve),
    meta: {
      title: '优惠券',
      keepAlive: false
    }
  },
  {
    path: '/mine-comment',
    name: 'mine-comment',
    component: (resolve) => require(['@/views/mine/mine-comment.vue'], resolve),
    meta: {
      title: '我的评论',
      keepAlive: false
    }
  },
  {
    path: '/mine-shareCode',
    name: 'mine-shareCode',
    component: (resolve) => require(['@/views/mine/mine-shareCode.vue'], resolve),
    meta: {
      title: '我的二维码',
      keepAlive: false
    }
  },
  {
    path: '/point-log-list',
    name: 'point-log-list',
    component: (resolve) => require(['@/views/mine/point-log-list.vue'], resolve),
    meta: {
      title: '积分记录',
      keepAlive: false
    }
  },
  {
    path: '/mine-balance-recharge',
    name: 'mine-balance-recharge',
    component: (resolve) => require(['@/views/mine/mine-balance-recharge.vue'], resolve),
    meta: {
      title: '钱包充值',
      keepAlive: false
    }
  },
  {
    path: '/mine-bfb',
    name: 'mine-bfb',
    component: (resolve) => require(['@/views/mine/mine-bfb.vue'], resolve),
    meta: {
      title: '百福币充值',
      keepAlive: false
    }
  },
  {
    path: '/bfb-log-list',
    name: 'bfb-log-list',
    component: (resolve) => require(['@/views/mine/bfb-log-list.vue'], resolve),
    meta: {
      title: '百福币记录',
      keepAlive: false
    }
  },
  {
    path: '/product-details/:id(\\d+)',
    name: 'product-details',
    component: (resolve) => require(['@/views/product-details/product-details.vue'], resolve),
    meta: {
      // 商品详情
      title: '百分百生活馆',
      keepAlive: false
    }
  },
  {
    path: '/product-list',
    name: 'product-list',
    component: (resolve) => require(['@/views/product/product-list.vue'], resolve),
    meta: {
      title: '商品列表',
      keepAlive: false
    }
  },
  {
    path: '/coupon-list',
    name: 'coupon-list',
    component: (resolve) => require(['@/views/coupon-list/coupon-list.vue'], resolve),
    meta: {
      title: '优惠券派送',
      keepAlive: false
    }
  },


  {
    path: '/mine-consult',
    name: 'mine-consult',
    component: (resolve) => require(['@/views/mine/mine-consult.vue'], resolve),
    meta: {
      title: '我的咨询',
      keepAlive: false
    }
  },

  // 
  {
    path: '/birth-company-list/:pid(\\d+)',
    name: 'birth-company-list',
    component: (resolve) => require(['@/views/birth-product/birth-company-list.vue'], resolve),
    meta: {
      title: '商品专区',
      keepAlive: false
    }
  },
  {
    path: '/birth-index',
    name: 'birth-index',
    component: (resolve) => require(['@/views/birth-product/birth-index.vue'], resolve),
    meta: {
      title: '专区首页',
      keepAlive: false
    }
  },
  {
    path: '/birth-company-product',
    name: 'birth-company-product',
    component: (resolve) => require(['@/views/birth-product/birth-company-product.vue'], resolve),
    meta: {
      title: '商品专区',  // 公司商品详情
      keepAlive: true
    }
  },
  {
    path: '/birth-goods',
    name: 'birth-goods',
    component: (resolve) => require(['@/views/birth-product/birth-goods.vue'], resolve),
    meta: {
      title: '专区商品详情',  // 公司商品详情
      keepAlive: false
    }
  },
  {
    path: '/birth-confirm-order',
    name: 'birth-confirm-order',
    component: (resolve) => require(['@/views/birth-product/birth-confirm-order.vue'], resolve),
    meta: {
      title: '专区确认订单',  // 公司 确认订单  
      keepAlive: false
    }
  },
  {
    path: '/product-tj',
    name: 'product-tj',
    component: (resolve) => require(['@/views/product-tj/product-tj.vue'], resolve),
    meta: {
      title: '特价商品',
      keepAlive: false
    }
  },
  // 多协会商品
  {
    path: '/association/:id',
    name: 'association',
    component: (resolve) => require(['@/views/ass_goods_list/ass_goods_list.vue'], resolve),
    meta: {
      title: '协会商品',
      keepAlive: false
    }
  },
  // 单协会商品
  {
    path: '/association-goods/:id/and/:skuid',
    name: 'association-goods',
    component: (resolve) => require(['@/views/association-goods/association-goods.vue'], resolve),
    meta: {
      title: '商品详情',  // 协会商品详情
      keepAlive: false
    }
  },
  {
    path: '/association-confirm-order',
    name: 'association-confirm-order',
    component: (resolve) => require(['@/views/association-goods/association-confirm-order.vue'], resolve),
    meta: {
      title: '确认订单',  // 协会商品详情
      keepAlive: false
    }
  },
  // 搜索模块


  {
    path: '/search',
    name: 'search',
    component: (resolve) => require(['@/views/search/search.vue'], resolve),
    meta: {
      title: '搜索',
      keepAlive: false
    }
  },
  {
    path: '/search-list',
    name: 'search-list',
    component: (resolve) => require(['@/views/search/search-list.vue'], resolve),
    meta: {
      title: '搜索列表',
      keepAlive: true
    }
  },
  {
    path: '/confirm-order',
    name: 'confirm-order',
    component: (resolve) => require(['@/views/product/confirm-order.vue'], resolve),
    meta: {
      title: '确认订单',
      keepAlive: false
    }
  },
  {
    path: '/pay-result',
    name: 'pay-result',
    component: (resolve) => require(['@/views/product/pay-result.vue'], resolve),
    meta: {
      title: '购买结果',
      keepAlive: false
    }
  },
  {
    path: '/comment-in',
    name: 'comment-in',
    component: (resolve) => require(['@/views/comment/comment-in.vue'], resolve),
    meta: {
      title: '发表评论',
      keepAlive: false
    }
  },
  {
    path: '/comment-see',
    name: 'comment-see',
    component: (resolve) => require(['@/views/comment/comment-see.vue'], resolve),
    meta: {
      title: '商品评论',
      keepAlive: false
    }
  },
  {
    path: '/order-list',
    name: 'order-list',
    component: (resolve) => require(['@/views/order/order-list.vue'], resolve),
    meta: {
      title: '订单',
      keepAlive: false
    }
  },
  {
    path: '/order-details',
    name: 'order-details',
    component: (resolve) => require(['@/views/order/order-details.vue'], resolve),
    meta: {
      title: '订单详情',
      keepAlive: false
    }
  },
  {
    path: '/order-express',
    name: 'order-express',
    component: (resolve) => require(['@/views/order/order-express.vue'], resolve),
    meta: {
      title: '物流信息',
      keepAlive: false
    }
  },
  {
    path: '/exchange',
    name: 'exchange',
    component: (resolve) => require(['@/views/exchange/exchange.vue'], resolve),
    meta: {
      title: '兑换',
      keepAlive: false
    }
  },
  // 兑换模块开始
  {
    path: '/exchange-goods-multiple',
    name: 'exchange-goods-multiple',
    component: (resolve) => require(['@/views/exchange/exchange-goods-multiple.vue'], resolve),
    meta: {
      title: '兑换列表',
      keepAlive: false
    }
  },
  {
    path: '/exchange-goods-details',
    name: 'exchange-goods-details',
    component: (resolve) => require(['@/views/exchange/exchange-goods-details.vue'], resolve),
    meta: {
      title: '商品详情',
      keepAlive: false
    }
  },
  {
    path: '/exchange-confirm-order',
    name: 'exchange-confirm-order',
    component: (resolve) => require(['@/views/exchange/exchange-confirm-order.vue'], resolve),
    meta: {
      title: '确认订单',
      keepAlive: false
    },
  },
  {
    path: '/exchange-pay-result',
    name: 'exchange-pay-result',
    component: (resolve) => require(['@/views/exchange/exchange-pay-result.vue'], resolve),
    meta: {
      title: '兑换结果',
      keepAlive: false
    }
  },
  {
    path: '/exchange-order-list',
    name: 'exchange-order-list',
    component: (resolve) => require(['@/views/exchange/exchange-order-list.vue'], resolve),
    meta: {
      title: '兑换订单',
      keepAlive: false
    }
  },
  {
    path: '/exchange-order-details',
    name: 'exchange-order-details',
    component: (resolve) => require(['@/views/exchange/exchange-order-details.vue'], resolve),
    meta: {
      title: '订单详情',
      keepAlive: false
    }
  },
  // 兑换模块结束












  

  {
    path: '/on-line-recharge',
    name: 'on-line-recharge',
    component: (resolve) => require(['@/views/on-line-recharge/on-line-recharge.vue'], resolve),
    meta: {
      // 在线充值
      title: '百分百生活馆',
      keepAlive: false
    }
  },
  {
    path: '/on-line-recharge-clause',
    name: 'on-line-recharge-clause',
    component: (resolve) => require(['@/views/on-line-recharge/on-line-recharge-clause.vue'], resolve),
    meta: {
      // 在线充值
      title: '百分百生活馆',
      keepAlive: false
    }
  },
  {
    path: '/receive-coupons',
    name: 'receive-coupons',
    component: (resolve) => require(['@/views/receive-coupons/receive-coupons.vue'], resolve),
    meta: {
      // 领取优惠券
      title: '百分百生活馆',
      keepAlive: false
    }
  },
  {
    path: '/join-us',
    name: 'join-us',
    component: (resolve) => require(['@/views/join-us/join-us.vue'], resolve),
    meta: {
      // 招商加盟
      title: '百分百生活馆',
      keepAlive: false
    }
  },
  {
    path: '/Join-form',
    name: 'Join-form',
    component: (resolve) => require(['@/views/Join-form/Join-form.vue'], resolve),
    meta: {
      // 招商加盟 s申请
      title: '百分百生活馆',
      keepAlive: false
    }
  },
  {
    path: '/car-guide',
    name: 'car-guide',
    component: (resolve) => require(['@/views/car-guide/car-guide.vue'], resolve),
    meta: {
      // 洗车指南
      title: '百分百生活馆',
      keepAlive: false
    }
  },
  {
    path: '/about',
    name: 'about',
    component: (resolve) => require(['@/views/about/about.vue'], resolve),
    meta: {
      //  关于我们
      title: '百分百生活馆',
      keepAlive: false
    }
  },
  {
    path: '/activity',
    name: 'activity',
    component: (resolve) => require(['@/views/activity/activity.vue'], resolve),
    meta: {
      // 活动
      title: '百分百生活馆',
      keepAlive: false
    }
  },
  {
    path: '/user',
    name: 'user',
    component: (resolve) => require(['@/views/user/user.vue'], resolve),
    meta: {
      // 个人中心
      title: '百分百生活馆',
      keepAlive: false
    }
  },
  {
    path: '/user-service',
    name: 'user-service',
    component: (resolve) => require(['@/views/user/user-service.vue'], resolve),
    meta: {
      // 我的信息
      title: '百分百生活馆',
      keepAlive: false
    }
  },
  {
    path: '/user-balance',
    name: 'user-balance',
    component: (resolve) => require(['@/views/user/user-balance.vue'], resolve),
    meta: {
      // 我的账户
      title: '百分百生活馆',
      keepAlive: false
    }
  },
  {
    path: '/balance-log-list',
    name: 'balance-log-list',
    component: (resolve) => require(['@/views/user/balance-log-list.vue'], resolve),
    meta: {
      // 账户明细
      title: '百分百生活馆',
      keepAlive: false
    }
  },
  {
    path: '/consume-log-list',
    name: 'consume-log-list',
    component: (resolve) => require(['@/views/user/consume-log-list.vue'], resolve),
    meta: {
      // 消费明细
      title: '百分百生活馆',
      keepAlive: false
    }
  },
  {
    path: '/balance-log-details',
    name: 'balance-log-details',
    component: (resolve) => require(['@/views/user/balance-log-details.vue'], resolve),
    meta: {
      // 账户明细详情
      title: '百分百生活馆',
      keepAlive: false
    }
  },
  {
    path: '/consume-log-details',
    name: 'consume-log-details',
    component: (resolve) => require(['@/views/user/consume-log-details.vue'], resolve),
    meta: {
      // 消费明细详情
      title: '百分百生活馆',
      keepAlive: false
    }
  },
  {
    path: '/apply-repair',
    name: 'apply-repair',
    component: (resolve) => require(['@/views/apply-repair/apply-repair.vue'], resolve),
    meta: {
      // 报修
      title: '百分百生活馆',
      keepAlive: false
    }
  },
  {
    path: '/wechart-qrcode',
    name: 'wechart-qrcode',
    component: (resolve) => require(['@/views/wechart-qrcode/wechart-qrcode.vue'], resolve),
    meta: {
      // 关注公众号
      title: '百分百生活馆',
      keepAlive: false
    }
  },
  {
    path: '/m-station-list',
    name: 'm-station-list',
    component: (resolve) => require(['@/views/m-manage/m-station-list.vue'], resolve),
    meta: {
      // 站点 - 商户
      title: '百分百生活馆',
      keepAlive: false
    }
  },
  {
    path: '/m-machine-list',
    name: 'm-machine-list',
    component: (resolve) => require(['@/views/m-manage/m-machine-list.vue'], resolve),
    meta: {
      // 设备 - 商户
      title: '百分百生活馆',
      keepAlive: false
    }
  },
  {
    path: '/m-order-list',
    name: 'm-order-list',
    component: (resolve) => require(['@/views/m-manage/m-order-list.vue'], resolve),
    meta: {
      // 订单 - 商户
      title: '百分百生活馆',
      keepAlive: false
    }
  },



  {
    path: '/Template',
    name: 'Template',
    component: (resolve) => require(['@/views/Template.vue'], resolve),
    meta: {
      title: '模板',
      keepAlive: false
    }
  },
];
export default routes;
